document.getElementById('toggle-menu-button').addEventListener('click', () => {
    const body = document.body;
    if (body.classList.contains('menu-open')) {
        body.classList.remove('menu-open');
    } else {
        body.classList.add('menu-open');
    }
});


// document.addEventListener('mouseover', (e) => {
//   if (e.target.classList.contains('filter-bw')) {
//       e.target.classList.add('unfilter');
//       e.target.classList.remove('filter-bw');
//   }
// });



// WEBPACK FOOTER //
// ./assets/js/src/modules/script.js